import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidebarBaseComponent } from './sidebar-base.component';
import { CustomerService, InvoiceService, NavigationService, ReminderService, StorageService } from '~core/services';


/**
 * Content for the customer search sidebar.
 */
@UntilDestroy()
@Component({
  selector: 'app-customer-overview-sidebar',
  template: `
  <nav class="esf-app-menu esf-accordion">
    <div class="esf-app-menu__unit">
      <div class="esf-app-menu__item">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.home'
          [routerLink]="['/club/' + this.selectedClub.id]">Home</a>
      </div>
      <div class="esf-app-menu__item">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.newSearch' [routerLink]="this.basicSearchLink">New search</a>
      </div>
      <div class="esf-app-menu__item">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.lastSearch' (click)="openLastSearch()"
          style="cursor: pointer;">Last search</a>
      </div>
      <div class="esf-app-menu__item esf-accordion__trigger" menuItem
          [ngClass]="{'-is-active': this.currentPage === 'customerOverview'}">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.customerProfile'
            [routerLink]="['/club/' + this.selectedClub.id + '/customer/' + this.currentId]">Customer Profile</a>
      </div>
      <div class="esf-app-menu__sub-items esf-accordion__target -is-open">
        <div class="esf-app-menu__sub-item" [ngClass]="{'-is-active': this.currentPage === 'lastContacts'}">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.lastContacts'
              [routerLink]="['/club/' + this.selectedClub.id + '/customer/' + this.currentId + '/contacts']">Last contacts</a>
        </div>
        <div class="esf-app-menu__sub-item" [ngClass]="{'-is-active': this.currentPage === 'reminders'}">
          <span [ngClass]="{'esf-badge': totalReminders !== 0}" [attr.data-badge]="totalReminders">
            <a i18n='Sidebar menu item@@sidebarComponent.menu.reminders'
                [routerLink]="['/club/' + this.selectedClub.id + '/customer/' + this.currentId + '/reminders']">Reminders</a>
          </span>
        </div>
        <div class="esf-app-menu__sub-item" [ngClass]="{'-is-active': this.currentPage === 'merchandising'}"
              *ngIf="selectedClub.isMerchandisingActive">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.merchandising'
              [routerLink]="['/club/' + this.selectedClub.id + '/customer/' + this.currentId + '/merchandising']">Merchandising</a>
        </div>
        <div class="esf-app-menu__sub-item" [ngClass]="{'-is-active': this.currentPage === 'ticketing'}">
          <span [ngClass]="{'esf-badge': totalReservations !== 0}" [attr.data-badge]="totalReservations">
            <a i18n='Sidebar menu item@@sidebarComponent.menu.ticketing'
                [routerLink]="['/club/' + this.selectedClub.id + '/customer/' + this.currentId + '/ticketing']">Ticketing</a>
          </span>
        </div>
        <div class="esf-app-menu__sub-item" [ngClass]="{'-is-active': this.currentPage === 'campaigns'}"
              *ngIf="selectedClub.isCampaignActive">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.campaignActivity'
              [routerLink]="['/club/' + this.selectedClub.id + '/customer/' + this.currentId + '/campaigns']">Campaign activity</a>
        </div>
        <div class="esf-app-menu__sub-item" [ngClass]="{'-is-active': this.currentPage === 'tixxSelectPage'}"
              *ngIf="selectedClub.isLotteryActive">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.tixxSelect'
              [routerLink]="['/club/' + this.selectedClub.id + '/customer/' + this.currentId + '/tixx-select']">Tixx-Select</a>
        </div>
        <div class="esf-app-menu__sub-item -is-active" *ngIf="this.currentPage === 'sepaMandates'">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.sepaMandates'>SEPA Mandates</a>
        </div>
      </div>
    </div>
  </nav>
  `
})
export class CustomerOverviewSidebarComponent extends SidebarBaseComponent implements OnDestroy {
  public isSearchOpened: boolean = false;
  public totalReminders: number;
  public totalReservations: number;
  public currentPage: string;

  constructor(
    storage: StorageService,
    router: Router,
    navigationService: NavigationService,
    route: ActivatedRoute,
    customerService: CustomerService,
    private reminderService: ReminderService,
    private invoiceService: InvoiceService
  ) {
    super(storage, route, navigationService, customerService, router);
    this.navigationService.castCurrentPage
      .pipe(untilDestroyed(this))
      .subscribe(data => this.currentPage = data);
    this.reminderService.castTotalOpenReminders.pipe(untilDestroyed(this)).subscribe((value: number) => this.totalReminders = value);
    this.invoiceService.castNumberOfReservations.pipe(untilDestroyed(this)).subscribe((value: number) => this.totalReservations = value);
  }

  public ngOnDestroy(): void { }
}
